import React from 'react';
import { useParams } from 'react-router-dom';
import Invoice from 'screens/Invoices/Invoice';
import InvoiceRouteAdmin, {
  InvoiceFlow
} from 'screens/Invoices/redesign/InvoiceRouteAdmin';
import useInvoiceFlags from 'screens/Invoices/redesign/hooks/useInvoiceFlags';

/**
 * Route guard for `/app/invoices/:id/edit`.
 *
 * When the redesign flag is active the new multi-step edit flow is rendered via
 * InvoiceRouteAdmin with the invoice id taken from the URL params.  When the
 * flag is off the legacy Invoice component handles the request.
 */
const InvoiceEditGuard: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { feInvoicesActive } = useInvoiceFlags();

  if (feInvoicesActive) {
    return <InvoiceRouteAdmin flow={InvoiceFlow.EDIT} invoiceId={id} />;
  }

  return <Invoice />;
};

export default InvoiceEditGuard;
